export default function SmallLoader() {
    return <div className="spinner-border text-primary small-loader" role="status">
        <span className="sr-only">Loading...</span>
    </div>
}